
/**
 * Gets the keys for an object.
 *
 * @return {Array} keys
 * @api private
 */

module.exports = Object.keys || function keys (obj){
  var arr = [];
  var has = Object.prototype.hasOwnProperty;

  for (var i in obj) {
    if (has.call(obj, i)) {
      arr.push(i);
    }
  }
  return arr;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/engine.io-parser/lib/keys.js
 ** module id = 693
 ** module chunks = 0 5
 **/